import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ModalBody } from 'reactstrap';
import UploadSource from '@shoflo/polymer/components/UploadSource/UploadSource';
import { getFileSourceType } from '@shoflo/polymer/utils/sourceFileHelper';
import { MEDIA_SOURCE_FORM } from 'constants/Modal';
import createSource from 'actions/source/createSource';
import useModal from 'hooks/useModal';

import { StyledModal } from './SourceForm.styled';
import { selectLastMediaSource } from '@shoflo/studio-redux/selectors/broadcastSourcesSelector';
import { useContentUploadedSLI } from '@studio/metrics/hooks/useContentUploadedSLI';
import { useFileUploadAction } from '@studio/metrics/hooks/useFileUploadAction';

const DEFAULT_ORDER_NUMBER = 0;

function SourceFormModal() {
  const dispatch = useDispatch();
  const { trackContentUploadedSLI } = useContentUploadedSLI();
  const { startFileUploadAction, endFileUploadAction } = useFileUploadAction();

  const { isOpen, clear } = useModal(MEDIA_SOURCE_FORM);

  let { order: lastMediaOrder = DEFAULT_ORDER_NUMBER } = useSelector(
    selectLastMediaSource
  );

  const endUploadSLICallback = props => {
    trackContentUploadedSLI(props);
    endFileUploadAction(props);
  };

  const createAndDispatchSource = source => {
    const fileType = getFileSourceType(source.value.name);
    dispatch(
      createSource(
        {
          ...source,
          type: fileType,
          order: lastMediaOrder + 1 // Increment last media source item order by 1
        },
        false,
        endUploadSLICallback,
        startFileUploadAction
      )
    );
  };

  const handleSubmitMultiFiles = sources => {
    sources.forEach(createAndDispatchSource);
    clear();
  };

  return (
    <StyledModal isOpen={isOpen} toggle={clear}>
      <ModalBody>
        <UploadSource onSubmit={handleSubmitMultiFiles} onCancel={clear} />
      </ModalBody>
    </StyledModal>
  );
}

export default SourceFormModal;
